function addLinkToBreadcrumbs(categoryObj, breadcrumbItemsObj) {
  if (categoryObj && categoryObj.link && categoryObj.label) {
    breadcrumbItemsObj[categoryObj.link.replace(/(\/)/g, '')] =
      categoryObj.label;
  }
}

export default addLinkToBreadcrumbs;
